import { render, staticRenderFns } from "./BlockDetailsCard.vue?vue&type=template&id=9dc021bc&"
import script from "./BlockDetailsCard.vue?vue&type=script&lang=js&"
export * from "./BlockDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports